import axios from "axios";
import React, { useState } from "react";
import { motion } from "framer-motion";

const Contact = () => {
  const [data, setData] = useState({
    email: "",
    data: "",
  });

  const changeHandler = (e) => {
    const { id, value } = e.target;
    setData((prevData) => ({
      ...prevData,
      [id]: value,
    }));
  };

  const submitHandler = async (e) => {
    e.preventDefault();
    if (!data.email || !data.data) return;

    try {
      const res = await axios.post(
        "https://portfolio-gnwha2eyt-shubhamshinde6762s-projects.vercel.app/api/v1/feedBackHandler",
        {
          email: data.email,
          data: data.data,
        }
      );
      console.log(res);
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <div className="min-w-[280px] w-full flex flex-col items-center gap-4 h-[85vh] overflow-y-scroll transition-all duration-300  rounded-xl p-4 px-6 flex-grow">
      <div className="font-bold font-poppins text-2xl transition-all duration-300 sx:text-xl">
        Contact
      </div>

      <form className="flex flex-col items w-full max-w-[500px] gap-4">
        <label className="flex flex-col">
          <motion.input
            id="email"
            className="bg-slate-100 rounded-lg px-2 font-poppins border-2 focus:ring-4 py-1"
            onChange={changeHandler}
            placeholder="Email"
            type="text"
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
          />
        </label>
        <label className="flex flex-col">
          <motion.textarea
            id="data"
            onChange={changeHandler}
            className="bg-slate-100 rounded-lg px-2 font-poppins border-2 focus:ring-4 py-1"
            placeholder="Write here"
            type="text"
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.2 }}
          />
        </label>
        <motion.div
          className="flex justify-center"
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.4 }}
        >
          <button
            className="px-2 py-1 bg-green-500 hover:bg-green-600 hover:scale-105 transition-all duration-300 rounded-lg text-white font-bold w-fit"
            onClick={submitHandler}
          >
            Submit
          </button>
        </motion.div>
      </form>
    </div>
  );
};

export default Contact;
